<template>
    <div class="profile-actions" :class="{open : open}">
        <div class="trigger" v-on:click="toggleOpen"><Avatar/></div>
        <div class="profile-menu">
            <ul>
                <li><router-link :to="{path:'/Profile'}" @click.native="closeMenu">Profile Details</router-link></li>
                <li><a href="#">Log out</a></li>
            </ul>
        </div>
        <div class="click-block" :class="{open: open}" v-on:click="closeMenu"></div>
    </div>


</template>

<script>
    import Avatar from '../profile/Avatar';
    export default {
        name: 'ProfileMenu',
        components: {Avatar},
        props: {
            'display': {
                type: Boolean,
                default: false
            }
        },
        data: function() {
            return {
                open: false
            };
        },
        computed: {
            menuOpen() {
                return this.$store.state.menu.open;
            }
        },
        watch: {
          menuOpen: function(val){
              if (val == true){
                this.closeMenu();  
              }
          }  
        },
        methods: {
            toggleOpen(e) {
                this.open = !this.open;
                if (this.menuOpen == true){
                    this.$store.dispatch('toggleMenu');
                }
                e.preventDefault();
            },
            closeMenu(e) {
                this.open = false;
                if (e !== undefined){
                    e.preventDefault;
                }
            }
        }
    };
</script>

<style scoped>
    
    .profile-actions {position: relative;}
        .profile-actions .trigger {cursor: pointer;}
        .profile-actions .profile-menu {background: #fff; position: absolute; right: -3.15rem; top: 3rem; width: 6rem; box-shadow: 0.1rem 0.1rem 0.5rem 0px rgba(0,0,0,0.25); overflow: hidden; max-height: 0; padding: 0; opacity: 0; transition: opacity .2s; z-index: 9999;}
        .profile-actions.open .profile-menu {padding: 1rem; max-height: 100vh; overflow: visible; opacity: 1;}
        .profile-actions .profile-menu:before {content: ''; display: block; width: 0; height: 0; border-style: solid; border-width: 0 .5rem .5rem .5rem; border-color: transparent transparent #ffffff transparent; position: absolute; left: 0; right: 0; top: -.5rem; margin: auto;}
            .profile-actions .profile-menu ul {list-style: none; padding: 0; margin: 0;}
                .profile-actions .profile-menu ul li {font-size: .75rem; text-align: center; user-select: none;}
                .profile-actions .profile-menu ul li + li {margin-top: .5rem;}
                    .profile-actions .profile-menu ul li a {color: #000;}
    
        .click-block {display: none; position: fixed; top: 2.75rem; right: 0; bottom: 0; left: 0; z-index: 999;}
        .click-block.open {display: block;}
    
</style>